import { timelineEvents } from "@/mocks/gossip";

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-secondary-50 py-16 md:py-24">
      <div className="shell grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-secondary-600">Timeline</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">蹲点日历</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            一天里发生了什么、几点发生的，按时间顺序排列。错过直播和热搜也不怕，回来翻日历就能补齐整条脉络。
          </p>

          <dl className="mt-7 space-y-4 rounded-lg border border-secondary-200 bg-background-50 p-5">
            <div className="flex items-start gap-3">
              <i className="ri-time-line mt-0.5 text-lg text-secondary-600" aria-hidden="true" />
              <div>
                <dt className="text-sm font-medium text-foreground-900">当日实时更新</dt>
                <dd className="mt-1 text-xs leading-6 text-foreground-600">热点出现即补录，时间点精确到分钟。</dd>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-filter-3-line mt-0.5 text-lg text-secondary-600" aria-hidden="true" />
              <div>
                <dt className="text-sm font-medium text-foreground-900">按分类追溯</dt>
                <dd className="mt-1 text-xs leading-6 text-foreground-600">每条事件都标注所属圈层，方便定向回溯。</dd>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-shield-check-line mt-0.5 text-lg text-secondary-600" aria-hidden="true" />
              <div>
                <dt className="text-sm font-medium text-foreground-900">标注信息来源</dt>
                <dd className="mt-1 text-xs leading-6 text-foreground-600">官方口径与网友反馈分开呈现，不做混谈。</dd>
              </div>
            </div>
          </dl>
        </div>

        <ol className="lg:pt-2">
          {timelineEvents.map((event) => (
            <li key={`${event.date}-${event.time}`} className="flex gap-4">
              <div className="w-14 shrink-0 pt-0.5 text-right">
                <p className="font-heading text-lg leading-tight text-secondary-700">{event.time}</p>
                <p className="mt-0.5 text-[11px] text-foreground-500">{event.date}</p>
              </div>
              <div className="relative flex-1 border-l-2 border-secondary-200 pb-7 pl-5 last:pb-0">
                <span className="absolute -left-[6px] top-2 h-3 w-3 rounded-full bg-secondary-500 ring-4 ring-secondary-50" aria-hidden="true" />
                <div className="rounded-lg border border-secondary-200 bg-background-50 p-4">
                  <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">{event.category}</span>
                  <p className="mt-2 text-sm leading-6 text-foreground-800">{event.title}</p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}